import { render } from "./MarketMini.vue?vue&type=template&id=33bf9b62"
import script from "./MarketMini.vue?vue&type=script&lang=js"
export * from "./MarketMini.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__